/**
 * Route for `email-notification-templates`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { EmailNotificationTemplatesPage } from "../features/email-notification-templates/EmailNotificationTemplatesPage";

export const emailNotificationTemplatesRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/email-notification-templates",
	component: EmailNotificationTemplatesPage,
});

export default emailNotificationTemplatesRoute;
